import { Stack, Typography, useTheme } from "@mui/material";
import { type Control, useController } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { FilterFormValues } from "web_myplann/Portfolio/Components/Redesign/Filter/filterFormSchema";
import { useFilterFormCategories } from "web_myplann/Portfolio/Components/Redesign/Filter/useFilterFormCategories";
import { portfolioGroupLabel } from "web_myplann/Portfolio/Helpers/portfolioCategoryMapping";
import { togglePortfolioCategory } from "web_myplann/Portfolio/Helpers/togglePortfolioCategory";
import type { PortfolioCategoryId } from "web_myplann/Portfolio/Types/portfolioCategory";
import { FlatRowSwitch } from "web_myplann/Shared/Components/FlatRow/FlatRowSwitch";

type Props = {
	control: Control<FilterFormValues>;
};

export const CategoryFilterSection = ({ control }: Props) => {
	const { t } = useResource();
	const theme = useTheme();
	const { availableCategories, categories } = useFilterFormCategories(control);
	const { field } = useController({ control, name: "categories" });
	const { onChange } = field;

	const isShown = (id: PortfolioCategoryId) =>
		categories.length === 0 || categories.includes(id);
	const shownCount = availableCategories.filter(isShown).length;

	const toggleCategory = (id: PortfolioCategoryId) =>
		onChange(togglePortfolioCategory(categories, id, availableCategories));

	return (
		<>
			<Typography variant="sectionLabel">
				{t(Resources.Portfolio.List.Redesign.Filter.categoriesLabel)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				{availableCategories.map((id, index) => (
					<FlatRowSwitch
						key={id}
						redesigned
						label={t(portfolioGroupLabel(id))}
						checked={isShown(id)}
						disabled={shownCount === 1 && isShown(id)}
						onChange={() => toggleCategory(id)}
						isLast={index === availableCategories.length - 1}
					/>
				))}
			</Stack>
		</>
	);
};
